'use strict';

module.exports = '2.24.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 347
// module chunks = 79611799117203